export default __webpack_public_path__ + "854266592edd8df0ddc9907550ea37c4.png";